import { FC } from 'react'
import classNames from 'classnames'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { GEyebrowLG } from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { PartnerLogo } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayConfigData'

interface Props {
  partnerLogos: PartnerLogo[]
}

export const CutoutSection: FC<Props> = ({ partnerLogos }) => {
  const { t } = useTranslate('tickets')

  if (!partnerLogos.length) return <div className={'h-[60px]'}></div>
  const partnerImage = partnerLogos[0]

  return (
    <div className={'relative'}>
      <FlexColumn className={classNames('mx-auto max-w-[1080px] gap-4  pt-[62px] md:pt-[132px] pb-0 md:pb-[50px]')}>
        <GEyebrowLG className="block text-center !font-semibold" color="giveaway-text-subtle-light">
          {t('handBuiltForVFX', 'Hand Built for VFX Artists and Creators by:')}
        </GEyebrowLG>
        <FlexRow className={'justify-end gap-9 md:justify-center'}>
          <div className={'hidden md:block'}>
            <Image src={partnerImage?.src ?? ''} alt={partnerImage?.alt} width={200} height={200} />
          </div>
          <div className={'md:hidden'}>
            <Image src={partnerImage?.src ?? ''} alt={partnerImage?.alt} width={140} height={140} />
          </div>
          <div className={'md:hidden'}>
            <Image
              src={'/v1751343473/young-washington/bbe6538e0abf8d0a66987d52c10c849f885025ba.png'}
              alt={'Freddie Wong'}
              width={128}
              height={188}
            />
          </div>
        </FlexRow>
      </FlexColumn>
      <FlexRow
        className={classNames(
          'mx-auto max-w-[1080px] gap-4  pb-10 md:pb-[60px] absolute top-0 right-0 w-full justify-end hidden md:flex',
        )}
      >
        <Image
          src={'/v1751343473/young-washington/bbe6538e0abf8d0a66987d52c10c849f885025ba.png'}
          alt={'Freddie Wong'}
          width={285}
          height={417}
        />
      </FlexRow>
    </div>
  )
}
